import React, { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { AUTO_RESET_TIMEOUT } from '../../utils/constants';
import dubaiPoliceLogo from '../../assets/dubai-police-logo.png';

const QRCodeScreen = ({ imageUrl, onDone, onAutoReset }) => {
  const [timeRemaining, setTimeRemaining] = useState(AUTO_RESET_TIMEOUT / 1000);

  useEffect(() => {
    const autoResetTimer = setTimeout(onAutoReset, AUTO_RESET_TIMEOUT);
    const countdownInterval = setInterval(() => {
      setTimeRemaining((prev) => Math.max(prev - 1, 0));
    }, 1000);
    return () => {
      clearTimeout(autoResetTimer);
      clearInterval(countdownInterval);
    };
  }, [onAutoReset]);

  return (
    <div className="h-screen relative overflow-hidden bg-gradient-to-b from-white via-[#F6FBF9] to-[#E4EFEA]">
      {/* Vertical spine */}
      <div className="forensic-spine" />

      {/* Background layers */}
      <div className="forensic-grid-overlay opacity-15" />
      <div className="forensic-map-overlay opacity-[0.05]" />
      <div className="forensic-fingerprint-texture opacity-40" />
      <div className="forensic-circuit-lines" />

      {/* Green blocks */}
      <div className="forensic-block forensic-block-1" />
      <div className="forensic-block forensic-block-2" />
      <div className="forensic-corner-tl" />
      <div className="forensic-corner-br" />

      {/* Main content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center px-8 text-center gap-6">
        {/* Logo */}
        <img src={dubaiPoliceLogo} alt="Dubai Police" className="h-14 w-auto mb-2" />

        {/* Title - Bilingual */}
        <div className="space-y-2">
          <p className="text-[10px] uppercase tracking-[0.3em] text-[#0e734b] font-tagline">
            Evidence Ready for Download
          </p>

          {/* Arabic title */}
          <h1 className="text-2xl text-[#0e734b] font-arabic font-black" dir="rtl">
            امسح الرمز لتحميل صورتك
          </h1>

          {/* English title */}
          <h2 className="text-3xl font-title uppercase text-[#1A1A1A]">
            Scan To Collect
          </h2>

          {/* Subtitle */}
          <p className="text-sm text-[#6B7770] font-title-light">
            Tag us to Enter A Raffle<br />
            <br />
            #DubaiPolice<br />
            #ForensicHero2025
          </p>
        </div>

        {/* QR Code */}
        <div className="forensic-card p-6 shadow-lg">
          <QRCodeSVG
            value={imageUrl}
            size={320}
            level="H"
            includeMargin
            bgColor="#FFFFFF"
            fgColor="#0e734b"
          />
        </div>

        {/* Timer - Bilingual */}
        <div className="flex items-center gap-3">
          <div className="w-2 h-2 bg-[#0e734b] rounded-sm animate-pulse" />
          <span className="text-sm uppercase tracking-[0.2em] text-[#4A5550] font-title-light">
            Session resets in <span className="text-[#1A1A1A] font-bold">{timeRemaining}s</span>
          </span>
          <span className="text-sm text-[#4A5550] font-arabic">
            — إعادة التعيين خلال
          </span>
          <div className="w-2 h-2 bg-[#0e734b] rounded-sm animate-pulse" />
        </div>

        {/* Complete button - Bilingual */}
        <button
          onClick={onDone}
          className="forensic-btn-primary px-12 py-4 text-base flex items-center gap-3"
        >
          <span className="font-title uppercase">Done</span>
          <span className="text-white/60">|</span>
          <span className="font-arabic font-bold">انتهى</span>
        </button>

        {/* Email Confirmation Notice - Bilingual */}
        <div className="mt-4 max-w-md text-center px-6 py-3 bg-[#E8F5E9] rounded-sharp border border-[#0e734b]/30">
          <div className="flex items-center justify-center gap-2 mb-2">
            <span className="text-[#0e734b] text-lg">✓</span>
            <div>
              <p className="text-sm text-[#0e734b] font-arabic font-bold" dir="rtl">
                تم إرسال البريد الإلكتروني بنجاح
              </p>
              <p className="text-sm text-[#0e734b] font-title font-semibold">
                Email Sent Successfully
              </p>
            </div>
          </div>
          <p className="text-xs text-[#4A5550] font-arabic leading-relaxed mb-1" dir="rtl">
            لقد أرسلنا صورتك إلى عنوان بريدك الإلكتروني.
          </p>
          <p className="text-xs text-[#4A5550] font-title-light leading-relaxed">
            We've sent your image to your email address.
          </p>
        </div>

        {/* Important Note - Bilingual */}
        <div className="mt-4 max-w-md text-center px-6 py-4 bg-[#F0F5F2] rounded-sharp border border-[#D1DDD7]">
          <p className="text-xs text-[#4A5550] font-title-light leading-relaxed mb-2">
            Please save your image. Images are automatically deleted from our database after 7 days.
          </p>
          <p className="text-xs text-[#4A5550] font-arabic leading-relaxed" dir="rtl">
            يرجى حفظ صورتك. يتم حذف الصور تلقائياً من قاعدة البيانات الخاصة بنا بعد 7 أيام.
          </p>
        </div>

      </div>
    </div>
  );
};

export default QRCodeScreen;
